import clsx from 'clsx'
import Link from 'next/link'
import { useCallback, useEffect, useState, type FunctionComponent } from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import type { ReferenceResult } from '../../data/ReferenceFragment'
import SvgChevronDown from '../../svg/icons/ChevronDown'
import { Button } from './Button'
import { Collapsible } from './Collapsible'
import style from './ReferenceGroup.module.sass'

interface ReferenceGroupProps {
	referenceList: { references: ReferenceResult[] }
	isOpen?: boolean
	close: () => void
}

export const ReferenceGroup: FunctionComponent<ReferenceGroupProps> = ({ referenceList, isOpen, close }) => {
	const [isReferenceListVisbile, setIsReferenceListVisbile] = useState(isOpen ?? false)
	const translate = useTranslate()

	useEffect(() => {
		if (isOpen) {
			setIsReferenceListVisbile(true)
		}
	}, [isOpen])

	const onClick = useCallback(() => {
		setIsReferenceListVisbile(!isReferenceListVisbile)
		close()
	}, [close, isReferenceListVisbile])

	return (
		<div className={style.root}>
			{referenceList && (
				<div className={style.buttonWrapper}>
					<Button
						label={translate('referenceGroup.button.sources')}
						iconAfter={
							<span className={clsx(style.buttonIcon, isReferenceListVisbile && style.buttonIconUp)}>
								<SvgChevronDown />
							</span>
						}
						type={{ variant: 'naked' }}
						onClick={onClick}
					/>
				</div>
			)}
			<Collapsible open={isReferenceListVisbile}>
				{referenceList &&
					referenceList.references
						.sort((a, b) => Number(a.order) - Number(b.order))
						.map((reference, index) => (
							<div key={reference.id} className={style.reference} id={String(index + 1)}>
								<span className={style.order}>{index + 1}.</span>
								{reference.link ? (
									<Link href={reference.link} target="_blank" className={style.referenceLink} title={reference.text}>
										{reference.text || reference.link}
									</Link>
								) : (
									reference.text
								)}
							</div>
						))}
			</Collapsible>
		</div>
	)
}
